import React from 'react';
import PropTypes from 'prop-types';
import { KB_TROUBLESHOOTING_URL, SLACK_SUPPORT_URL, TEAM_EMAIL } from '~/features/base/constants/supportLinks';

/**
 * Classifies an authentication error message.
 * @param {string} errorMessage
 * @returns {'aadsts16000' | 'generic'}
 */
export const classifyAuthError = (errorMessage) => {
    if (typeof errorMessage === 'string' && errorMessage.toLowerCase().includes('aadsts16000')) {
        return 'aadsts16000';
    }
    return 'generic';
};

export const AuthErrorPage = ({ errorType, onRetryLogin }) => {
    return (
        <div className='display-flex flex-column align-items-center justify-content-center' style={{ minHeight: '100vh' }}>
            <div className='max-width-600 padding-left-20 padding-right-20'>
                <h1 className='text-size-h2 text-color-darker margin-bottom-10'>Sign-in failed</h1>
                <span className='text-size-16 text-color-dark'>
                    Authentication could not be completed. Please try one of the following steps to resolve the issue.
                </span>

                {errorType === 'aadsts16000' && (
                    <div className='bs-callout bs-callout-warning margin-top-20'>
                        <h4 className='text-bold'>Multiple accounts detected</h4>
                        <span className='text-color-dark'>
                            Your browser has sessions from multiple Azure AD accounts, which caused a conflict.
                            Please select a different account or use a private browsing window.
                        </span>
                    </div>
                )}

                <h4 className='text-bold margin-top-25 margin-bottom-10'>Troubleshooting steps</h4>
                <ol className='text-color-dark text-size-14'>
                    <li className='margin-bottom-5'>
                        Delete cookies for this site (Settings → Privacy → Cookies → search for the site domain and remove all entries), then reload the page.
                    </li>
                    <li className='margin-bottom-5'>
                        Open a Chrome incognito window with third-party cookies allowed and try signing in again.
                    </li>
                    <li className='margin-bottom-5'>
                        Try using a different browser or browser profile.
                    </li>
                    <li className='margin-bottom-5'>
                        If the issue persists, contact us via{' '}
                        <a href={SLACK_SUPPORT_URL} target='_blank' rel='noopener noreferrer' className='text-color-primary'>Slack support channel</a>
                        {' '}or email{' '}
                        <a href={`mailto:${TEAM_EMAIL}`} className='text-color-primary'>{TEAM_EMAIL}</a>.
                    </li>
                </ol>

                <div className='margin-top-15'>
                    <a href={KB_TROUBLESHOOTING_URL} target='_blank' rel='noopener noreferrer' className='text-color-primary text-size-14'>
                        <span className='uikit-icon icon-book margin-right-5'></span>
                        Full troubleshooting guide
                    </a>
                </div>

                <button
                    type='button'
                    className='btn btn-primary margin-top-20'
                    onClick={onRetryLogin}
                >
                    <span className='uikit-icon icon-refresh margin-right-5'></span>
                    Sign in again
                </button>
            </div>
        </div>
    );
};

AuthErrorPage.propTypes = {
    errorType: PropTypes.oneOf(['aadsts16000', 'generic']).isRequired,
    onRetryLogin: PropTypes.func.isRequired,
};

export default AuthErrorPage;
